module.exports = __webpack_public_path__ + "static/media/g2wNewLogo.38686344.svg";


//////////////////
// WEBPACK FOOTER
// ./src/StaticAssets/Images/g2wNewLogo.svg
// module id = 911
// module chunks = 0